import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    MatButtonModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule,
    MatSlideToggleModule, MatToolbarModule, MatTooltipModule, MatSelectModule, MatMenuModule, MatCheckboxModule,
    MatChipsModule, MatListModule, MatProgressBarModule, MatRippleModule, MatSidenavModule, MatPaginatorModule, MatTableModule, MatTabsModule,
} from '@angular/material';
import { ColorPickerModule } from 'ngx-color-picker';
import { CalendarModule as AngularCalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseMaterialColorPickerModule, FuseWidgetModule } from '@fuse/components';
import { CalendarComponent } from './calendar.component';
import { CalendarService } from './calendar.service';
import { CalendarEventFormDialogComponent } from './event-form/event-form.component';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ScrumboardLabelSelectorComponent } from './event-form/label-selector/label-selector.component';
import { MatRadioModule } from '@angular/material/radio';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { MatOptionModule } from '@angular/material/core';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { MyLeaveComponent } from './my-leave/my-leave.component';
import { TeamLeaveComponent } from './team-leave/team-leave.component';
import { HolidaysComponent } from './holidays/holidays.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/primeng';
import { TableModule } from 'primeng/components/table/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CalendarDatePickerComponent } from './calendar-date-picker/calendar-date-picker.component';
import { SharedModule } from 'app/shared/shared.module';


const routes = [

    { path: '', redirectTo: '', pathMatch: 'full', canActivate: [AuthGuardService] },
    {
        path: 'calendar',
        component: CalendarComponent,
        children: [],
        resolve: {
            chat: CalendarService
        },
        canActivate: [AuthGuardService],
    },
    { path: 'my-leave', component: MyLeaveComponent, canActivate: [AuthGuardService] },
    { path: 'team-leave', component: TeamLeaveComponent, canActivate: [AuthGuardService] },
    { path: 'holidays', component: HolidaysComponent, canActivate: [AuthGuardService] }
];

@NgModule({
    declarations: [
        CalendarComponent,
        CalendarEventFormDialogComponent,
        ScrumboardLabelSelectorComponent,
        MyLeaveComponent,
        TeamLeaveComponent,
        HolidaysComponent,
        MonthPickerComponent,
        CalendarDatePickerComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatRadioModule,
        MatMenuModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSlideToggleModule,
        MatToolbarModule,
        MatTooltipModule,
        MatSelectModule,
        MatCheckboxModule,
        MatOptionModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        MatRadioModule,
        MatAutocompleteModule,
        NgxDnDModule,
        FuseSharedModule,
        FuseConfirmDialogModule,
        FuseMaterialColorPickerModule,
        RichTextEditorAllModule,
        AngularCalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        ColorPickerModule,
        FuseSharedModule,
        FuseConfirmDialogModule,

        FlexLayoutModule,
        TableModule,
        MultiSelectModule,
        FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatPaginatorModule,
        MatTableModule,
        FuseWidgetModule,
        NgxMaterialTimepickerModule,
        SharedModule
    ],
    providers: [
        CalendarService
    ],
    entryComponents: [
        CalendarEventFormDialogComponent
    ]
})

export class CalendarModule {

}
